import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as Sentry from "@sentry/react";
const root = ReactDOM.createRoot(document.getElementById('root'));
const dsn = process.env.REACT_APP_SENTRY_DSN;

if (dsn) {
  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV,
    sendDefaultPii: false, // or true if you accept IP etc.
    integrations: [
      Sentry.browserTracingIntegration(),
      // optional: Sentry.replayIntegration({ ... }),
    ],
    tracesSampleRate: process.env.NODE_ENV === "production" ? 0.1 : 0,
  });
}
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
